const availableJobs = [
  {
    name: "Program Manager II",
    skill: "Production Group",
    team: "Review ",
    jobType: "Remote",
  },
  {
    name: "Full-stack Developer",
    skill: "programming",
    team: "Programming ",
    jobType: "Remote",
  },
  {
    name: "Data base engineer",
    skill: "programming",
    team: "Programming ",
    jobType: "Remote",
  },
];
export default availableJobs;
